/**
 * The journal's Feedback page route (PLAN-JOURNAL-LABELS D-JL7).
 *
 * `/blending/$blendId/feedback`'s sibling and wired the same way: the page is
 * router-free and takes its navigation as callbacks. "Print a card" hands the
 * run over as one id under `?journals=`, beside the `?batches=` and `?blends=`
 * the other two kinds use (D-JL6). The nightly digest links here.
 *
 * No return ticket. This page is reached from the journal and goes back to it,
 * and the journal is the one holding the list's ticket (D-LS8).
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { JournalFeedbackPage } from '@/components/journal/journal-feedback';

export const Route = createFileRoute('/journals/$journalId/feedback')({
  component: JournalFeedbackRoute,
});

function JournalFeedbackRoute() {
  const { journalId } = Route.useParams();
  const navigate = useNavigate();
  return (
    // Keyed on the id because the router reuses this component when only the
    // param changes, and the page's hook keeps what it had across an id
    // change: without the key, one journal's sheets would stand in for the
    // next.
    <JournalFeedbackPage
      key={journalId}
      journalId={journalId}
      onBack={() => {
        void navigate({ to: '/journals/$journalId', params: { journalId } });
      }}
      onPrintCard={() => {
        void navigate({ to: '/batches/tasting-cards', search: { journals: journalId } });
      }}
    />
  );
}
